import React, { useContext, useEffect, useState } from 'react'
import './Login.css'
import { useHistory } from 'react-router-dom'
import PrimaryButton from '@/product/components/atoms/PrimaryButton'
import { useFormik } from 'formik'
import AuthContext from '@/product/context/auth/authContext'
import { handleRedirectInternal, mapData } from '@/product/common/components'
import { useTranslation } from 'react-i18next'
import * as Yup from 'yup'
import { Link } from 'react-router-dom'
import PhoneValidationComponent from '@/product/components/species/components/user/PhoneValidationComponent'
import Tabs from '@material-ui/core/Tabs'
import Tab from '@material-ui/core/Tab'
import Box from '@material-ui/core/Box'
import Button from '@material-ui/core/Button'
import FacebookLogin from 'react-facebook-login/dist/facebook-login-render-props'
// import { useGoogleLogin, GoogleLogin } from '@react-oauth/google'
import googleImg from '../../assets/images/Google.png'
import facebookImg from '../../assets/images/fb.png'
import jwtDecode from 'jwt-decode'
function TabPanel(props) {
    const { children, value, index, ...other } = props
    return (
        <div
            className="pv-tab-panel"
            id={`pv-tab-panel-${index}`}
            hidden={value !== index}
            aria-labelledby={`pv-tab-panel-${index}`}
        >
            {value === index && <Box className="">{children}</Box>}
        </div>
    )
}

function allyProps(index) {
    return {
        id: `pv-tab-panel-${index}`,
        'aria-controls': `pv-tab-panel-${index}`,
    }
}

const LoginComponent = (props) => {
    const history = useHistory()
    const authContext = useContext(AuthContext)
    const { t } = useTranslation()
    let [isLoginPhone, setIsLoginPhone] = useState(false)
    const { login, responseStatus, clearResponse, isAuthenticated } = authContext
    const [phoneVerify, setPhoneVerify] = useState(false)
    const [value1, setValue1] = useState(0)

    const handleTabs1 = (event, newValue) => {
        setValue1(newValue)
    }

    const changePhoneVerify = () => {
        setPhoneVerify(!phoneVerify)
    }
    useEffect(() => {
        if (isAuthenticated) {
            handleRedirectInternal(history, '')
        }
    }, [isAuthenticated])

    const processSocialLogin = (email, token) => {
        props.formik.values.email = email
        props.formik.values.google_id = token
        props.login(props.formik.values)
    }

    const responseGoogle = async (response) => {
        const token = response.access_token

        try {
            const response = await fetch('https://www.googleapis.com/oauth2/v3/userinfo', {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            })

            const userInfo = await response.json()
            if (userInfo?.email) {
                console.log('Google Login Response Inside ', userInfo)
                processSocialLogin(userInfo?.email, token)
            }
        } catch (error) {
            console.error('Failed to fetch user info - google login', error)
        }

        // const userDetails = jwtDecode(response.access_token)
        // console.log('Google Login Response Inside ', response, userDetails)
        // props.formik.values.email = userDetails.email
        // props.formik.values.google_id = userDetails.jti
        // props.login(props.formik.values)
    }

    // const responseGoogle = (response) => {
    //     const userDetails = jwtDecode(response.credential)
    //     formik.values.email = userDetails.email
    //     formik.values.google_id = userDetails.jti
    //     // console.log(formik, 'hhhhhhhhhhhh')
    //     login(formik.values)
    // }

    const responseFacebook = async (response) => {
        if (response?.email) {
            processSocialLogin(response?.email, response.accessToken)
        }
    }

    const validationArrayPhone = Yup.object({
        phone: Yup.string()
            .trim()
            .matches(/^[0-9- +()]*$/g, 'Only numbers are allowed')
            .max(16, 'Maximum 10 Number')
            .min(15, 'Invalid Phone Number')
            .required('Required!'),
        password: Yup.string().when('isLoginPhone', {
            is: (e) => !e,
            then: Yup.string().required('Password is required'),
            otherwise: Yup.string().notRequired(),
        }),
    })
    const formik = useFormik({
        initialValues: {
            type: '1',
            phone_verifysent: 0,
            phone: localStorage.phone ? localStorage.phone : '',
            isLoginPhone: false,
            ...props.initialValues,
        },
        validateOnBlur: false,
        validationSchema: validationArrayPhone,

        onSubmit: (values) => {
            if (values.remember_me) {
                localStorage.phone = values.phone
                localStorage.password = values.password
                localStorage.remember_me = values.remember_me
            } else {
                delete localStorage.phone
                delete localStorage.password
                delete localStorage.remember_me
            }
            values.phonePasswordLogin = !isLoginPhone
            values.otpLogin = isLoginPhone
            if (isLoginPhone) {
                changePhoneVerify()
            } else {
                login(values)
            }
        },
    })

    // const googleLogin = useGoogleLogin({
    //     onSuccess: (credentialResponse) => {
    //         console.log('Google Login Response ', credentialResponse)
    //         responseGoogle(credentialResponse)
    //     },
    //     onError: (e) => {
    //         console.error('Google Login Response ERROR', e)
    //     },
    // })

    // useEffect(() => {
    //     setIsLoginPhone(value1 == 0 ? false : true)
    // }, [value1])
    const rememberMe = {
        formik: formik,
        data: [
            {
                label: t('remember_me'),
                name: 'remember_me',
                type: 'checkbox',
                placeholder: 'remember_me',
                class: 'loginCheck col-12',
            },
        ],
    }
    const loginInfo = {
        formik: formik,
        data: props.loginInfo,
    }

    useEffect(() => {
        console.log('LOCAL VSTORAGE', localStorage)
    })
    useEffect(() => {
        if (responseStatus) {
            if (responseStatus.from === 'login') {
                if (responseStatus.status === 'success') {
                    if (props.onSuccess) {
                        props.onSuccess()
                    } else {
                        handleRedirectInternal(history, 'search')
                    }
                }
            }
        }
    }, [responseStatus])
    const submitFn = (value) => {
        formik.setErrors({})
        setIsLoginPhone(value)
        formik.setFieldValue('isLoginPhone', value)

        formik.values.isLoginPhone = value
        formik.handleSubmit()
    }
    return (
        <>
            <PhoneValidationComponent
                phoneVerify={phoneVerify}
                formik={formik}
                setPhoneVerify={setPhoneVerify}
                changePhoneVerify={changePhoneVerify}
                isLogin={true}
            />
            {/* <div className="row">{Object.values(mapData(checkinData))}</div> */}

            <div className="row">{Object.values(mapData(loginInfo))}</div>
            {props.rememberMe && <div className="row">{Object.values(mapData(rememberMe))}</div>}
            {props.forgotPassword && (
                <div className="forgotPass">
                    <Link to="/forgot_password">{'Forgot password'}</Link>
                </div>
            )}
            <div className="row loginActionBtn">
                <PrimaryButton
                    label={t('Sign In')}
                    type="submit"
                    onClick={() => {
                        submitFn(false)
                    }}
                    btnSize="large"
                    // disabled={isLoginPhone ? true : !(formik.isValid && formik.dirty)}
                    className="col-sm-6"
                />
                <PrimaryButton
                    label={t('Sign In using OTP')}
                    onClick={() => {
                        submitFn(true)
                    }}
                    type="submit"
                    btnSize="large"
                    // disabled={!(formik.values.phone && !formik.errors.phone && formik.dirty)}
                    className="col-sm-6 btnWithBorder"
                />
            </div>

            {/* <>
                <hr className="loginLine" />
                <div className="loginLine">
                    <hr />
                    <span>OR YOU CAN SIGNIN VIA</span>
                    <hr />
                </div>
                <div className="googleSignUp mb-4 mt-4 d-flex align-items-center justify-content-center">
                    <div className="googleBtn" onClick={() => googleLogin()}>
                    <Button
                        variant="outlined"
                        onClick={() => googleLogin()}
                        className="fbSignup"
                        color="default"
                    >
                        <object
                            aria-label="Facebook Signin"
                            data="/assets/svg/googleImage.svg"
                            type="image/svg+xml"
                        ></object>
                        <div className="line"></div>
                        <span className="customGoogleAuth">Google</span>
                        <img className="btmImageComman" src={googleImg} />
                    </Button>
                    {props.googleSignIn ? (
                        <div className="googleBtn" onClick={() => googleLogin()}>
                            <div className="customGoogleAuth">Continue with google</div>
                            <img src="/assets/svg/googleImage.svg" />
                        </div>
                    ) : null}
                    </div>

                    {props.facebookLogin ? (
                        <div>
                            <FacebookLogin
                                appId={process.env.REACT_APP_FACEBOOK_APP_ID}
                                fields="name,email"
                                callback={responseFacebook}
                                render={(renderProps) => (
                                    <Button
                                        variant="outlined"
                                        onClick={renderProps.onClick}
                                        className="fbSignup"
                                        color="default"
                                    >
                                        <img className="btmImageComman" src={facebookImg} />
                                    </Button>
                                )}
                            />
                        </div>
                    ) : null}
                </div>
                <p className="loginHelp">
                    {'New to iQuippo'}?&nbsp;
                    <Link to="/registration/customer" className="loginLink">
                        {'SignUp'}
                    </Link>
                </p>
            </> */}
        </>
    )
}

export default LoginComponent
